import React from 'react'

interface Props{
    isImageOpened: boolean,
    ImageSrc: any
    contextualMenu: boolean
}

interface State{}

class ImageGallery extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isImageOpened && this.props.contextualMenu ? 'full-gallery-main fade-in':'full-gallery-main fade-out'}>
                <div className={this.props.isImageOpened && this.props.contextualMenu ? "image-gallery-main fade-in":"image-gallery-main fade-out"}>
                    <img src={this.props.ImageSrc}/>
                </div>
            </div>
        )
    }
}

export default ImageGallery